<template>
    <video ref="fmVideo" controls autoplay/>
</template>

<script>
import Plyr from 'plyr';
import modal from '../mixins/modal';

export default {
  name: 'Player',
  mixins: [modal],
  data() {
    return {
      player: {},
    };
  },
  mounted() {
    let user = JSON.parse(localStorage.getItem('user'));
    // initiate video player
    this.player = new Plyr(this.$refs.fmVideo);
    // load source
    this.player.source = {
      type: 'video',
      title: this.videoFile.filename,
      sources: [{
        src: `${process.env.VUE_APP_DEFAULT_URL }/file-manager/preview?user_id=${user.id}&disk=public&path=${encodeURIComponent(this.videoFile.path)}`,        
        type: `audio/${this.videoFile.extension}`,
      }],
    };
  },
  beforeDestroy() {
    this.player.destroy();
  },
  computed: {
    /**
     * Selected disk
     * @returns {*}
     */
    selectedDisk() {
      return this.$store.getters['selectedDisk'];
    },

    /**
     * Video file
     * @returns {*}
     */
    videoFile() {
      return this.$store.getters['selectedItems'][0];
    },
  },
  methods: {
  },
};
</script>

<style lang="scss">
    
</style>
